// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
const firebaseConfig = {
  apiKey: "AIzaSyAC3HDGr55tDoHrmxll8X13XtfRBjDMsoM",
  authDomain: "vdeploy-2d908.firebaseapp.com",
  projectId: "vdeploy-2d908",
  storageBucket: "vdeploy-2d908.firebasestorage.app",
  messagingSenderId: "367267046074",
  appId: "1:367267046074:web:fd9d57cc264bf558931883",
};

const app = initializeApp(firebaseConfig);
// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);
export default app;
